import { render } from "./configmap.vue?vue&type=template&id=49fe3e17"
import script from "./configmap.vue?vue&type=script&lang=js"
export * from "./configmap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__